import { useDocumentMetadata } from '../hooks/useDocumentMetadata';
import { BRAND, FOUNDERS } from '../lib/constants';
import styles from './LetterheadPage.module.css';

/**
 * Company letterhead — legal/fiscal details for quotes, invoices, onboarding forms.
 * Deliberately unlisted: no nav/footer link, excluded from the sitemap, blocked in
 * robots.txt, and marked noindex — see useDocumentMetadata's `noindex` flag. This
 * keeps it out of search results and site navigation, not behind real access control.
 */
export const LetterheadPage = () => {
  useDocumentMetadata('Intestazione Societaria | NexTrainE', undefined, true);

  return (
    <div className={styles.page}>
      <div className={styles.sheet}>
        <div className={styles.header}>
          <img src="/logo.svg" alt="" aria-hidden="true" width={400} height={400} className={styles.logo} />
          <div>
            <p className={styles.name}>{BRAND.legal}</p>
            <p className={styles.badge}>Spin-off {BRAND.university} · Startup Innovativa</p>
          </div>
        </div>

        <dl className={styles.fields}>
          <div className={styles.field}>
            <dt>Ragione Sociale</dt>
            <dd>{BRAND.legal}</dd>
          </div>
          <div className={styles.field}>
            <dt>Partita IVA</dt>
            <dd>{BRAND.vat.replace('P.IVA ', '')}</dd>
          </div>
          <div className={styles.field}>
            <dt>Sede Legale</dt>
            <dd>
              {BRAND.address}
              <br />
              {BRAND.postalCode} {BRAND.city} ({BRAND.province})
            </dd>
          </div>
          <div className={styles.field}>
            <dt>Codice Destinatario (SDI)</dt>
            <dd>{BRAND.sdi}</dd>
          </div>
          <div className={styles.field}>
            <dt>Email</dt>
            <dd>{BRAND.email}</dd>
          </div>
        </dl>

        <div className={styles.founders}>
          <p className={styles.foundersLabel}>Co-Founder</p>
          <p className={styles.foundersList}>{FOUNDERS.map((f) => f.name).join(' · ')}</p>
        </div>
      </div>
    </div>
  );
};
